import React, { forwardRef, useRef, useContext } from "react";
import { LoadingSvg } from "../../icons/Icon";
import { Loading } from "../Loaders";
import { useEventContext } from "../../contexts/EventContextProvider";
import ExpandableTokens from "../../widgets/ExpandableTokens";

const VariantDiscountsDisplayBar = forwardRef((p, r) => {

    const { state, eventDispatch } = useEventContext();

    const render = (p) => {
        return (
            <div className="flex-row" ref={r}>
                <div className="col-24">
                    <div className="ListItemDetails">
                        <div className="flex-column">
                            <div className="flex-row">
                                <div className="col-24">
                                    <ExpandableTokens list={p.discounts} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
    const renderCase = (state) => {
        switch (true) {
            case state?.state == 'LOADING':
                return <Loading><LoadingSvg /></Loading>;
            case state.visibility:
                return render(state.data);
            case state?.state == 'ERROR':
                return <></>;
            default:
                return <></>;
        }
    }
    return (state?.variantDiscounts && state.variantDiscounts[p.id]) ? renderCase(state.variantDiscounts[p.id]) : <></>;
});

export default VariantDiscountsDisplayBar;